import moment from 'moment';
import { DateTime } from 'src_common/utils/time/time';

const openBankingDetails = (row) => {
    return row?.paymentDetails?.name;
};

const cardDetails = (row) => {
    const expires = row?.paymentDetails?.expires ?? null;
    if (expires === null){
        return row.paymentType;
    }
    const formatedExpires = DateTime.from(expires)?.format('MM/YY');
    return `${row.paymentType}, ${formatedExpires}`;
};

const formatDetails = (row) => {
    if (row?.paymentDetails?.type === 'open-banking'){
        return openBankingDetails(row);
    }

    return cardDetails(row);
};

export const COLUMNS = [
    {
        name: 'createdAt',
        label: 'Time',
        minWidth: 0,
        value: row => (row.time ?? null) === null ? null: moment(row.time).format('DD/MM/YYYY HH:mm')
    },
    {
        name: 'id',
        label: 'Transaction No.',
        minWidth: 0,
        value: row => row.id
    },
    {
        name: 'Customer Account No.',
        label: 'account.id',
        minWidth: 0,
        value: row => row['account.id']
    },
    {
        name: 'name',
        label: 'Customer Name',
        minWidth: 0,
        value: row => row.customerName
    },
    {
        name: 'type',
        label: 'Transaction Type',
        minWidth: 0,
        value: row => row.transactionType
    },
    {
        name: 'provider',
        label: 'Provider',
        minWidth: 0,
        value: row => row.paymentDetails?.provider
    },
    {
        name: 'details',
        label: 'Details',
        minWidth: 0,
        value: row => formatDetails(row)
    },
    {
        name: 'currency',
        label: 'Currency',
        minWidth: 0,
        value: row => row.currency
    },
    {
        name: 'status',
        label: 'Status',
        minWidth: 0,
        value: row => row.status
    },
    {
        name: 'amount',
        label: 'Amount',
        minWidth: 0,
        value: row => row.amount
    },
    {
        name: 'playableBalance',
        label: 'Playable Balance',
        minWidth: 0,
        value: row => row.playableBalanceAfter
    },
    {
        name: 'withdrawableBalance',
        label: 'Withdrawable Balance',
        minWidth: 0,
        value: row => row.withdrawableBalanceAfter
    },
    {
        name: 'failedWithdrawalsFunds',
        label: 'Failed Withdrawals Funds',
        minWidth: 0,
        value: row => row.failedWithdrawalsFundsAfter
    }
];
